// extracted by mini-css-extract-plugin
export var banner = "_jo-0";
export var settingRow = "_jo-2";
export var titleIcon = "_jo-1";